import axios from "axios";
import {browserHistory} from "react-router";
import FileSaver from 'file-saver';

import {
  SET_NAV,
  PROCESSING,
  FORM_PROCESSING,
  COMPLETED,
  AUTH_USER,
  UNAUTH_USER,
  LOAD_DATA,
  LOAD_FILTERED_DATA,
  DATA_ERROR,
  SET_MESSAGES,
  DB_TYPE,
  DB_LIST,
  RESIZE,
  LOADING_FILES,
  FILE_LOAD_FAILED,
  FILE_LOAD_SUCCESS,
  UPDATE_CHECKS,
  DELETE_FILE_SUCCESS,
  TOGGLE_DELETE
} from './types';

// const ROOT_URL = 'http://localhost:8081';
const ROOT_URL = "https://mntd.co:8081";;


export function setNav(navbaritems){
    return {
      type: SET_NAV,
      payload: navbaritems
    };
}

export function reSize(width,height){
    var dim = {width,height};
    return {
      type: RESIZE,
      payload: dim
    };
}


export function signinUser({ email, password }) {
  return function(dispatch) {
    dispatch(processingData());
    axios.post(`${ROOT_URL}/signin`, { email, password })
      .then(response => {
        // If request is good...
        // - Update state to indicate user is authenticated
        // - Save the JWT token
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('name', `${response.data.firstname} ${response.data.lastname}`);
        dispatch({ type: AUTH_USER });
        // - redirect to the route '/feature'
        browserHistory.push('/');
      })
      .catch(() => {
        // If request is bad...
        // - Show an error to the user
        var messages = {msg1: "Sorry", msg2: "Login Invalid or Not Enabled"}
        dispatch(setMessage(messages));
        browserHistory.push('/message');
      });
  }
}

export function signupUser({ email, password, firstname, surname }) {
    return function(dispatch) {
        dispatch(processingData());
        axios.post(`${ROOT_URL}/signup`, { email, password, firstname, surname })
          .then(response => {
            var messages = {msg1: "Thanks", msg2: "Your Access is Pending"};
            dispatch(setMessage(messages));
            browserHistory.push('/message');
          })
          .catch(response => dispatch(setMessage(response.data.error)));
  }
}

export function saveIdea(Idea) {
    return function(dispatch) {
        dispatch(processingData());
        axios.post(`${ROOT_URL}/saveidea`, Idea,{
          headers: { authorization: localStorage.getItem('token') }
        })
          .then(response => {
            var messages = {msg1: "Done", msg2: "Saved", button: "Add Another", path: "newidea"}
            dispatch(setMessage(messages));
            browserHistory.push('/message');
          })
          .catch(response => console.log(response))
  }
}

export function setMessage(messages) {
  return {
    type: SET_MESSAGES,
    payload: messages
  };
}

export function signoutUser() {
  localStorage.removeItem('token');
  localStorage.removeItem('name');
  return { type: UNAUTH_USER };
}

export function processingData(){
    return { type: PROCESSING };
}

export function loadingForm(){
    return { type: FORM_PROCESSING };
}

export function dataError(data){
    return { type: DATA_ERROR };
}

export function receiveData(data){
    return {
      type: LOAD_DATA,
      payload: data.data.recordset
    };
}

export function filterData(data,applyfilter,columns,filter,isDate){
    var filtereddata = [];
    var addedIDs = {};
    if (applyfilter) {
        for (var i = 0; i < data.length; i++){
            for (var col = 0; col < columns.length; col++){
                if (filter === '*') {
                    if (data[i][columns[col]] !== null) {
                        if(data[i][columns[col]] !== "") {
                            if (!addedIDs[data[i]['ID']]) {
                                filtereddata.push(data[i]);
                                addedIDs[data[i]['ID']] = true;
                            }
                        }
                    }
                } else {
                    if (isDate) {
                        var d = data[i][columns[col]].split("T")[0].split("-");
                        var formatedDate = new Date(d[0],(d[1]-1),d[2]);
                        if (formatedDate >= filter) {
                            filtereddata.push(data[i]);
                        }
                    } else {
                        if (data[i][columns[col]] === filter) {
                            filtereddata.push(data[i]);
                        }
                    }
                }
            }
        }
    } else {
        filtereddata = data;
    }
    // console.log(filtereddata);
    // console.log(addedIDs);
    return {
      type: LOAD_FILTERED_DATA,
      payload: filtereddata
    };
}

export function changeSaved(updateddata){
    if (updateddata){
        return {
          type: COMPLETED,
          payload: updateddata
        };
    } else {
        return { type: COMPLETED };
    }
}

export function callAPI(dbtype, body, formData) {
    return function(dispatch){
        if (body.action === 'get'|| body.action === 'add' || body.action === 'updatemany') {
            dispatch(processingData());
        }
        axios.post(`${ROOT_URL}/${dbtype}`, body,{
          headers: { authorization: localStorage.getItem('token') }
        })
            .then(response => {
                if (body.action === 'add') {
                    var messages = {msg1: "Done", msg2: "Saved", button: "Add Another", path: "add"}
                    dispatch(setMessage(messages));
                    browserHistory.push('/message');
                    dispatch(setDBType(dbtype));
                } else if (body.action === 'updatemany') {
                    dispatch(changeSaved(body.data));
                } else {
                    dispatch(receiveData(response));
                }
          })
          .catch(dispatch(dataError()))
    }
}

export function goToPage (dbtype,addorview){
    return function (dispatch){
        dispatch(setDBType(dbtype));
        browserHistory.push(`/${addorview}`);
    }
}

export function setDBType (dbtype){
    localStorage.setItem('dbtype', dbtype);
    return {
      type: DB_TYPE,
      payload:dbtype
    };
}

export function getDBList(loaddblist,dbtype,id) {
    return function(dispatch){
        if (loaddblist) {
            dispatch(loadingForm());
            axios.get(`${ROOT_URL}/idea`,{
                headers: { authorization: localStorage.getItem('token') }
            }).then(response => {
                dispatch(setDBList(response));
                if (id) { dispatch(downloadFileList(id));}
            }).catch(() => {
                dispatch(dataError());
            });
        } else {
            dispatch(downloadFileList(id));
        }
    }
}

function setDBList (data) {
    var dblist = data.data.recordset.map(Idea => ({value: Idea.ID, text: Idea.Name}));
    return {
      type: DB_LIST,
      payload: dblist
    };
}

export function callAPIwithSetDB (dbtype, body){
    return function(dispatch){
        dispatch(setDBType(dbtype));
        dispatch(callAPI(dbtype,body));
    }
}

export function uploadFile (id, file) {
    return function(dispatch){
        dispatch(loadingFiles());
        var fr = new FileReader();
        fr.readAsArrayBuffer(file.blob);
        fr.onload = function () {
            var data = new Uint8Array(fr.result);
            var body = {id: id, file: file, data: data};
            axios.post(`${ROOT_URL}/testfile`, body, {
                headers: { authorization: localStorage.getItem('token') }
            }).then(response => {
                file.id = response.data;
                dispatch(fileLoadSuccess(file));
            }).catch(() => {
                dispatch(fileLoadFail());
            });
        }
    };
}

function loadingFiles () {
    return { type: LOADING_FILES };
}

function fileLoadFail () {
    return { type: FILE_LOAD_FAILED };
}

function fileLoadSuccess (file) {
    return {
        type: FILE_LOAD_SUCCESS,
        payload: file
    };
}

function downLoadSuccess (file) {
    return {
        type: FILE_LOAD_SUCCESS
    };
}

export function deleteFiles (files) {
    return function(dispatch){
        dispatch(loadingFiles ());
        var idlist = [];
        for (var j = 0; j < files.length; j++){
            if (files[j].checked){
                idlist.push(files[j].id)
            }
        }
        var body = {ids: idlist};
        if (idlist.length > 0) {
            axios.post(`${ROOT_URL}/deletetestfiles`, body, {
                headers: { authorization: localStorage.getItem('token') }
            }).then(response => {
                dispatch(deleteFileSuccess());
            }).catch(() => {
                dispatch(fileLoadFail());
            });
        } else {
            dispatch(deleteFileSuccess());
        }
    }
}

function deleteFileSuccess () {
    return {
        type: DELETE_FILE_SUCCESS
    };
}

export function updateChecks (index){
    return {
        type: UPDATE_CHECKS,
        payload: index
    };
}

export function downloadFileList (id) {
    return function(dispatch){
        dispatch(loadingFiles());
        var body = {id: id};
        axios.post(`${ROOT_URL}/gettestfiles`, body, {
            headers: { authorization: localStorage.getItem('token') }
        }).then(response => {
            dispatch(fileLoadSuccess(response.data.recordset));
        }).catch(() => {
            dispatch(fileLoadFail());
        });
    };
}

export function downloadFile (file) {
    return function(dispatch){
        dispatch(loadingFiles());
        var body = {id: file.id};
        axios.post(`${ROOT_URL}/gettestfile`, body, {
            headers: { authorization: localStorage.getItem('token') }
        }).then(response => {
            var contentarray = new Uint8Array(response.data.recordset[0].Content.data);
            var blob = new Blob([new DataView(contentarray.buffer)], {type: file.type});
            FileSaver.saveAs(blob,file.name)
            dispatch(downLoadSuccess());
        }).catch(() => {
            dispatch(fileLoadFail());
        });
    };
}

export function toggleDelete (checked){
    return {
        type: TOGGLE_DELETE,
        payload: checked
    };
}



// WEBPACK FOOTER //
// ./src/actions/index.js